import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { login } from '@src/redux/authenticator';
import { LutienApi } from '@src/services/lutien/lutien-api';
import { useAppDispatch } from '@src/redux/hooks';

import { LoginView } from './LoginView';

export const LoginContainer = () => {
  const [email, setEmail] = useState<string>('');
  const [password, setPassword] = useState<string>('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(false);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleSubmit = async () => {
    if (!email || !password) return;

    setIsLoading(true);
    setError(false);

    try {
      const result = await dispatch(login({ email, password }));

      if (login.fulfilled.match(result)) {
        navigate('/');
      } else {
        setError(true);
      }
    } catch {
      setError(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSSO = async () => {
    setIsLoading(true);
    setError(false);
    try {
      const lutienApi = new LutienApi();
      const { hostedUi } = await lutienApi.v1.auth.getHostedUiUrl({ workspace: 'ad' });
      if (hostedUi) {
        const url = new URL(hostedUi);
        url.searchParams.set('redirect_uri', `${window.location.origin}/url/auth`);
        window.location.href = url.toString();
        return;
      }
      setError(true);
    } catch {
      setError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <LoginView
      error={error}
      handleSubmit={handleSubmit}
      isLoading={isLoading}
      setEmail={setEmail}
      setPassword={setPassword}
      isReady={!!password && !!email}
      handleSSO={handleSSO}
    />
  );
};
